import React, { useEffect, useState } from 'react';
import { Check, X } from 'lucide-react';
const buyers = [{
  name: 'Coach Chris',
  location: 'Dallas',
  minutes: 2
}, {
  name: 'Coach Marcus',
  location: 'Chicago',
  minutes: 9
}, {
  name: 'Coach Tyrell',
  location: 'Atlanta',
  minutes: 14
}, {
  name: 'Coach Jordan',
  location: 'Los Angeles',
  minutes: 6
}, {
  name: 'Coach Andre',
  location: 'Houston',
  minutes: 21
}];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(showTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(i => (i + 1) % buyers.length);
        setVisible(true);
      }, 800);
    }, 9000);
    return () => clearInterval(cycle);
  }, [visible]);
  const buyer = buyers[idx];
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-199">
      <div className="bg-white rounded-2xl shadow-2xl border border-bb-line p-3 pr-4 flex items-center gap-3 max-w-[300px]" data-id="element-200">
        <div className="bg-bb-orange w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-201">
          <Check className="w-5 h-5 text-white" strokeWidth={3} data-id="element-202" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-203">
          <p className="text-sm font-semibold text-bb-charcoal leading-tight truncate" data-id="element-204">
            {buyer.name} from {buyer.location}
          </p>
          <p className="text-xs text-bb-slate leading-tight mt-0.5" data-id="element-205">
            Just purchased • {buyer.minutes} min ago •{' '}
            <span className="text-bb-orange font-semibold" data-id="element-206">
              Verified Purchase
            </span>
          </p>
        </div>
        <button onClick={() => setVisible(false)} className="text-bb-slate hover:text-bb-charcoal flex-shrink-0" aria-label="Close" data-id="element-207">
          <X className="w-4 h-4" data-id="element-208" />
        </button>
      </div>
    </div>;
}